import { css } from '@emotion/css';

export const buttonStyles = css`
  min-width: unset !important;
  height: 3.2rem !important;
  .arrow-icon {
    width: 1.6rem !important;
    height: 1.6rem !important;
  }

  .MuiButton-startIcon {
    margin-inline-end: 0.4rem;
  }

  &.selected {
    box-shadow: inset 0 0 0 2px var(--text-primary);
    border-color: transparent;
  }
`;
